import SettingBasic from './SettingBasic';

export default SettingBasic;
